var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner app-main-page-tab",
      attrs: { type: "primary" }
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", flex: "1", height: "100%" } },
        [
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": { overflow: "hidden" },
                "right-style": {
                  flex: "none",
                  "max-width": "50%",
                  width: "20%"
                }
              }
            },
            [
              _c(
                "template",
                {
                  style: {
                    minWidth: "190px",
                    border: "1px solid #ccc",
                    height: "100%",
                    width: "80%"
                  },
                  slot: "left"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        height: "100%",
                        "overflow-y": "auto"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "flex-grow": "1"
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              !_vm.isAllowEdit
                                ? [
                                    _c(
                                      "search-item",
                                      {
                                        ref: "searchItem",
                                        attrs: {
                                          "config-module": "2350",
                                          reset: true,
                                          "expand-adv": false,
                                          "custom-sim-query-placeholder": _vm.$t(
                                            "CargoMsg.QuickSearchUser"
                                          ),
                                          "col-settings": {
                                            style: "width: 516px;"
                                          }
                                        },
                                        on: {
                                          "click-more": function(value) {
                                            _vm.isAdvancedQuery = value
                                          },
                                          simSearchItemCallBack:
                                            _vm.toSimpleQuery,
                                          advSearchItemCallBack:
                                            _vm.toAdvancedQuery
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "operations" },
                                          [
                                            !_vm.ojEnable
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    style: {
                                                      marginLeft: _vm.isAdvancedQuery
                                                        ? "5px"
                                                        : "",
                                                      marginRight: "5px"
                                                    },
                                                    attrs: {
                                                      "split-button": "",
                                                      type: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.userManagerCommandHandle()
                                                      },
                                                      command: function(p) {
                                                        _vm.userManagerCommand = p
                                                        _vm.userManagerCommandHandle()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm.userManagerCommand !==
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Import"
                                                    )
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userManagerCommand
                                                            )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm.userManagerCommand ===
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Import"
                                                    )
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Import"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown"
                                                        },
                                                        slot: "dropdown"
                                                      },
                                                      [
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: _vm.$t(
                                                                "CargoMsg.Cargo_Add"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "CargoMsg.Cargo_Add"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: _vm.$t(
                                                                "CargoMsg.Cargo_Import"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "CargoMsg.Cargo_Import"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: _vm.$t(
                                                                "CargoMsg.Cargo_DownLoad_Template"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "CargoMsg.Cargo_DownLoad_Template"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled: !_vm.selectedData
                                                },
                                                on: { click: _vm.toEditUser }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Edit"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            !_vm.ojEnable
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      disabled:
                                                        _vm.notAllowEditActive
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.toEditUserActive
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentActive
                                                          ? _vm.$t(
                                                              "CargoMsg.Cargo_Invalid2"
                                                            )
                                                          : _vm.$t(
                                                              "CargoMsg.Cargo_Activation"
                                                            )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: { click: _vm.fetchList }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Refresh"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.selectedRows ||
                                                    _vm.selectedRows.length <=
                                                      0,
                                                  type: "primary"
                                                },
                                                on: { click: _vm.batchEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.BatchProcessing"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click:
                                                    _vm.userSecurityPolicyHandler
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_UserSecurityPolicy"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-bottom": "10px",
                                          "margin-top": "5px"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              disabled: _vm.btnSaveEnable
                                            },
                                            on: { click: _vm.toSubmit }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Save")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.toCancel }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Cancel")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm.oneFormData.uuid
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.toRoleManagment
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_RoleGroupManagement"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "triggers" },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    inline: true,
                                    "label-width": "60px",
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-right": "10px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_RecordCount"
                                                ) + ":"
                                              ) +
                                              " " +
                                              _vm._s(_vm.rowData.length)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "85%" },
                            attrs: {
                              "config-module": "20221129",
                              "show-side-bar": false,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData,
                              "grid-options": _vm.gridOptions,
                              "side-bar": _vm.sideBarDefs
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.userGridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "section ",
                          staticStyle: { width: "100%", "padding-top": "15px" }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "form",
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: {
                                "label-width": "100px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row",
                                  staticStyle: { width: "100%", height: "100%" }
                                },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      attrs: {
                                        "label-width": _vm.isZh
                                          ? "100px"
                                          : "160px",
                                        "label-position": "left"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 10 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_LoginName"
                                                    ),
                                                    prop: "actualAmountNo"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.login,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "login",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.login"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_ChineseNamed"
                                                    ),
                                                    prop: "paymentCompany"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    style:
                                                      _vm.isAllowEdit &&
                                                      _vm.isHM &&
                                                      !_vm.oneFormData.uuid
                                                        ? "width:75%"
                                                        : "",
                                                    attrs: {
                                                      disabled:
                                                        _vm.oujianEditLimit ||
                                                        (_vm.isHM &&
                                                          _vm.oneFormData.uuid)
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .chineseName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "chineseName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.chineseName"
                                                    }
                                                  }),
                                                  _vm.isAllowEdit &&
                                                  _vm.isHM &&
                                                  !_vm.oneFormData.uuid
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.openChooseThirdUser
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Select"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_email"
                                                    ),
                                                    prop: "companyBank"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.oujianEditLimit ||
                                                        (_vm.isHM &&
                                                          _vm.oneFormData.uuid)
                                                    },
                                                    nativeOn: {
                                                      keyup: function($event) {
                                                        return _vm.onEmailChange(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.email,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.email"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_MobilePhoneNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        !_vm.isAllowEdit ||
                                                        (_vm.isHM &&
                                                          _vm.oneFormData.uuid)
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.cell,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "cell",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.cell"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_PasswordExpirationDate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    style: { width: "100%" },
                                                    attrs: {
                                                      type: "date",
                                                      disabled: !_vm.isAllowEdit,
                                                      placeholder: " "
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .expirationDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "expirationDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.expirationDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.CargoMsg_QQ"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      value: _vm.oneFormData.qq,
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    on: { input: _vm.onQqInput }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm.ojEnable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.CargoMsg_CorporateName"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.oujianEditLimit
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.oneFormData
                                                              .thirdPartyName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.oneFormData,
                                                              "thirdPartyName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "oneFormData.thirdPartyName"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_RoleGroup"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .userGroupText,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "userGroupText",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.userGroupText"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Password"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      value:
                                                        _vm.oneFormData
                                                          .password,
                                                      type: "password",
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    on: {
                                                      input: _vm.onPasswordInput
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_EnglishNamed"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .englishName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "englishName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.englishName"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Tel"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.phone,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "phone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.phone"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Fax"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.fax,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "fax",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.fax"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Superior"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .basic_data_User,
                                                      "callback-params": {
                                                        key: "manager"
                                                      },
                                                      "callback-method-type":
                                                        "value",
                                                      "default-value": _vm
                                                        .oneFormData.manager
                                                        ? _vm.oneFormData
                                                            .manager
                                                        : "",
                                                      "method-params": {
                                                        officeId:
                                                          _vm.oneFormData
                                                            .defaultOfficeId
                                                      },
                                                      filterable: "",
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.getValueFromChild
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_NetworkManagementCode"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: !_vm.isAllowEdit,
                                                      maxlength: 2
                                                    },
                                                    nativeOn: {
                                                      keyup: function($event) {
                                                        return _vm.netCodeChange(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData.netCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "netCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.netCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    float: "left"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_ElectricitySupplierAccountOrNot"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-checkbox", {
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .externalUser,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "externalUser",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.externalUser"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              !_vm.isPlatformMaintenance
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticStyle: {
                                                        float: "left",
                                                        "margin-left": "40px"
                                                      },
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_SystemAdministrator"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("el-checkbox", {
                                                        attrs: {
                                                          disabled: !_vm.isAllowEdit
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.isSystemAdmin,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.isSystemAdmin = $$v
                                                          },
                                                          expression:
                                                            "isSystemAdmin"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    "margin-left": "40px"
                                                  },
                                                  attrs: { "label-width": "0" }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "SystemMaintenance.NonLoginUser"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        placement: "top",
                                                        content: _vm.$t(
                                                          "SystemMaintenance.ValidUserNotNeedLogin"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-question",
                                                        staticStyle: {
                                                          color: "#1989fa",
                                                          "font-size": "16px"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c("el-checkbox", {
                                                    staticStyle: {
                                                      "margin-left": "10px"
                                                    },
                                                    attrs: {
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .isDisableLogin,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "isDisableLogin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.isDisableLogin"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    clear: "both"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_TheCompanyToWhichTheAccountBelongs"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      maxlength: 2
                                                    },
                                                    nativeOn: {
                                                      keyup: function($event) {
                                                        return _vm.netCodeChange(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .partnerUUIDStr,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "partnerUUIDStr",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.partnerUUIDStr"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_UserCompany"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .basic_data_Office,
                                                      "default-value": _vm
                                                        .oneFormData
                                                        .defaultOfficeId
                                                        ? _vm.oneFormData
                                                            .defaultOfficeId
                                                        : "",
                                                      filterable: "",
                                                      placeholder: " ",
                                                      disabled: !_vm.isAllowEdit
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.officeChange
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_UserDepartment"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "cargo-department-select",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isAllowEdit,
                                                        "callback-params": {
                                                          key: "defaultDepId"
                                                        },
                                                        "office-id": Number(
                                                          _vm.oneFormData
                                                            .defaultOfficeId
                                                        ),
                                                        enables: true,
                                                        placeholder: " ",
                                                        "department-id": Number(
                                                          _vm.oneFormData
                                                            .defaultDepId
                                                        )
                                                      },
                                                      on: {
                                                        change: function(p) {
                                                          _vm.oneFormData.defaultDepId =
                                                            p.value || 0
                                                        }
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_UserCode"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.oujianEditLimit ||
                                                        (_vm.isHM &&
                                                          _vm.oneFormData.uuid),
                                                      maxlength: 32
                                                    },
                                                    nativeOn: {
                                                      keyup: function($event) {
                                                        return _vm.userCodeChange(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormData
                                                          .userCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormData,
                                                          "userCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormData.userCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              !_vm.isPlatformMaintenance
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_ExternalAssociationCode"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: !_vm.isAllowEdit
                                                        },
                                                        nativeOn: {
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.externalAssociationCodeChange(
                                                              $event
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.oneFormData
                                                              .externalCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.oneFormData,
                                                              "externalCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "oneFormData.externalCode"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isPlatformMaintenance
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticStyle: {
                                                        float: "left"
                                                      },
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_SystemAdministrator"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("el-checkbox", {
                                                        attrs: {
                                                          disabled: !_vm.isAllowEdit
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.isSystemAdmin,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.isSystemAdmin = $$v
                                                          },
                                                          expression:
                                                            "isSystemAdmin"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isPlatformMaintenance
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticStyle: {
                                                        float: "left",
                                                        "margin-left": "40px"
                                                      },
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_PlatformCustomerService"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("el-checkbox", {
                                                        attrs: {
                                                          disabled: !_vm.isAllowEdit
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handleCheckboxChange
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.oneFormData
                                                              .isPlatformCustomer,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.oneFormData,
                                                              "isPlatformCustomer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "oneFormData.isPlatformCustomer"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      },
                      attrs: {
                        action: _vm.URL.sys.userImport,
                        data: Object.assign(
                          { activeUserCount: _vm.activeUserCount },
                          _vm.$store.state.settings.bsLimitInfo
                        ),
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "before-upload": _vm.beforeUpload,
                        "on-success": _vm.uploadSuccess,
                        "on-error": _vm.handleError
                      }
                    },
                    [_c("el-button", { ref: "uploadBtn" })],
                    1
                  )
                ],
                1
              ),
              _c(
                "template",
                {
                  staticStyle: {
                    "min-width": "190px",
                    width: "20%",
                    border: "1px solid #ccc"
                  },
                  slot: "right"
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.officeDeptTree.gridOptions,
                      "column-defs": _vm.officeDeptTree.columnDefs,
                      "row-data": _vm.officeDeptTree.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              "check-content": _vm.oneFormData,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("user-security-policy-dialog", {
        attrs: { visible: _vm.userSecurityPolicyDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.userSecurityPolicyDialog, "visible", $event)
          }
        }
      }),
      _c("batch-modify-user-dialog", {
        attrs: {
          visible: _vm.batchModifyUserDialog.visible,
          user: _vm.batchModifyUserDialog.user,
          "user-keys": _vm.batchModifyUserDialog.userKeys
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchModifyUserDialog, "visible", $event)
          },
          callback: _vm.batchModifyUserCallback
        }
      }),
      _c("choose-third-User-dialog", {
        attrs: { visible: _vm.chooseUserDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chooseUserDialog, "visible", $event)
          },
          callBack: _vm.thirdUserSelected
        }
      }),
      _c("role-group-dialog", {
        attrs: {
          visible: _vm.roleGroupDialog.visible,
          "user-id": _vm.roleGroupDialog.userId,
          "user-groups": _vm.selectedData ? _vm.selectedData.userGroups : [],
          "current-roles": _vm.selectedData ? _vm.selectedData.roles : []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.roleGroupDialog, "visible", $event)
          },
          callback: _vm.selectedUserGroups
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }